<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#000000"/>
    <path d="M12.4307 14.2941C15.6366 14.2941 15.6366 17.1765 12.1722 17.1765C9.65269 17.1765 9.65268 16.1471 9.65268 16.1471" stroke="#000000" stroke-linejoin="round"/>
    <path d="M12.4872 14.2941C9.0228 14.2941 9.02281 11.6176 12.4872 11.6176C14.3768 11.6176 14.3768 12.4412 14.3768 12.4412" stroke="#000000" stroke-linejoin="round"/>
    <path d="M13 10.5V11.5M13 17V18" stroke="#000000" stroke-linejoin="round"/>
    <path d="M11 10.5V11.5" stroke="#000000" stroke-linejoin="round"/>
    <path d="M11 17V18"  stroke="#000000" stroke-linejoin="round"/>
    <path d="M8.99999 8.5C6.99999 10.5 2.49998 20 8.49998 20C12.5 20 11 20 15 20C21.5 20 18 12 15 8.5M8.99999 8.5H15M8.99999 8.5C8.49999 8.33333 7.09999 7.80001 7.49999 7.00001C7.99999 6.00001 9.49999 7.20712 9.49999 6.50001C9.49999 5.5 9.76832 5.49997 11 5.5C11.5 5.50001 12 5.5 12 7.00001C12 6.50001 12 5.5 14 5.50001C14.5 5.50002 14.5 6.00001 14.5 6.50001C15 7 16.5 6 16.5 7C16.5 7.49999 15 8.5 15 8.5" stroke="#000000" stroke-linejoin="round"/>
  </svg>
</template>
<script>
import Vue from 'vue';

const IconInvestor = Vue.extend({
  name: 'icon-investors',
  props: {
    color: {
      type: String,
      default: '#000',
    },
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    style() {
      return `stroke: ${this.color};`;
    },
  },
});
export default IconInvestor;
</script>

<style scoped lang="scss">
  /* stylelint-disable */
  .a,
  .b {
    fill: none;
    stroke: #000;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 0.7px;
  }

  .b {
    stroke-miterlimit: 10;
  }
</style>
